import React from 'react'
import {ErrorBoundary} from '@sentry/nextjs'

import TrackingAnimation from './components/TrackingAnimation'
import useOrder from './hooks/useOrder.main'
import useStatus from './hooks/useStatus'
import Map from './sections/Map'

export default function Left() {
  const status = useStatus()
  const {order} = useOrder()

  if (status === 'cancelled') {
    return <div className="lg:bg-slate-100 lg:h-full" />
  }

  if (status === 'delivery' && order.delivery) {
    return (
      <ErrorBoundary
        fallback={<div className="text-red-500 p-4">Ocurrió un error al imprimir el mapa.</div>}>
        <Map />
      </ErrorBoundary>
    )
  }

  return <TrackingAnimation />
}
